// extracted by mini-css-extract-plugin
module.exports = {"quantityChoicesWrapper":"QuantityChoices_quantityChoicesWrapper__1rqN9","choices":"QuantityChoices_choices__1Qbtz"};